export enum FormName {
  PregledKursa = 'Pregled kurseva',
  PregledUgovora = 'Pregled ugovora',
  PregledPodugovora = 'Pregled podugovora',
  Podugovor = 'Podugovor',
  TipUgovora = 'TipUgovora',
  StatusUgovora = 'StatusUgovora',
  KorekcijaUgovor = 'KorekcijaUgovor',
  KorekcijeCenovnika = 'KorekcijeCenovnika',
  AdministracijaKorisnika = 'Administracija korisnika',
  PregledCenovnika = 'Pregled cenovnika',
  PregledSpotova = 'Pregled spotova',
  PregledProgama = 'PregledProgama',
  SifarnikBanaka = 'SifarnikBanaka',
  PregledEmisija = 'PregledEmisija',
  PregledKlijenata = 'Pregled klijenata',
  SifarnikBrendova = 'Šifarnik brendova',
  SifarnikVrstaSpota = 'Šifarnik vrsta spota',
  SifarnikMedijuma = 'Šifarnik medijuma',
  SifarnikOdluka = 'SifarnikOdluka',
  SifarnikCiljnihGrupa = 'SifarnikCiljnihGrupa',
  SifarnikNacinaObracuna = 'SifarnikNacinaObracuna',
  SifarnikNacinaPlacanja = 'SifarnikNacinaPlacanja',
  MediaPlan = 'MediaPlan',
  VrstaUsluge = 'VrstaUsluge',
  Montaza = 'Montaza',
  MontazaKalendar = 'Montaza kalendar',
  AvecoParser = 'AvecoParser',
  PregledKorekcija = 'PregledKorekcija',
  VideoUputstva = 'VideoUputstva',
  RealizacijaUgovora = 'RealizacijaUgovora',
  Verifikacija = 'Verifikacija',
  BesplatnaEmitovanja = 'BesplatnaEmitovanja',
  ObracunCPPGranicnaVrednost = 'ObracunCPPGranicnaVrednost',
  PregledZeljenihPozicija = 'PregledZeljenihPozicija',
}



// WEBPACK FOOTER //
// ./src/app/enums/form-name.enum.ts